/** Buffer limit of events */
export const MAX_BUFFER_SIZE = 1000;
//# sourceMappingURL=telemetryTypes.js.map